import React from 'react';
import { Container, Tab, Tabs, Typography } from '@mui/material';
import EquipmentExpander from './EquipmentExpander';
import EquipmentTrendsByUnit from '../EquipTrendsByUnit/EquipmentTrendsByUnit';
import AssetPointTable from '../AssetPointTable/AssetPointTable';

import './EquipSingle.css';

const getTabContents = (tabVal, equipId) => {
  switch (tabVal) {
    case 'trends':
      return <EquipmentTrendsByUnit equipmentId={equipId} />;
    case 'summary':
    default:
      return <AssetPointTable equipmentId={equipId} />;
  }
};

const TABS = ['summary', 'trends'];

const EquipSingleView = ({ equipment, tab, handleTabChange }) => {
  if (!equipment) {
    return <div>Something went wrong, please try again later</div>;
  }
  const tabIndex = Math.max(TABS.indexOf(tab), 0);
  return (
    <div>
      <Container>
        <div className="EquipSingle-summary">
          <Typography>{`Name: ${equipment.display.fullName}`}</Typography>
          <Typography>{`Type: ${equipment.display.typeName}`}</Typography>
          <Typography>{`Tags: ${
            equipment.tags
              .concat(equipment.labels)
              .map((t) => `#${t}`)
              .join(', ') || ''
          }`}</Typography>
          <Typography>{`Building: ${equipment.buildingName}`}</Typography>
          <Typography>{`Physical Location: ${equipment.physLocation}`}</Typography>
          <Typography>{`Points: ${equipment.points?.length || 0}`}</Typography>
        </div>
      </Container>
      <Tabs
        indicatorColor="secondary"
        textColor="inherit"
        value={tabIndex}
        onChange={(e, index) => handleTabChange(TABS[index])}
      >
        <Tab key="summary" label="Summary" />
        <Tab key="trends" label="Trends" />
      </Tabs>
      <div>
        <EquipmentExpander equipmentId={equipment.id} alwaysExpanded>
          {getTabContents(tab, equipment.id)}
        </EquipmentExpander>
      </div>
      {equipment.children?.length > 0 && (
        <div>
          <Typography variant="subtitle1">
            <p>Connected Assets</p>
          </Typography>
          <div>
            {equipment.children.map((id) => (
              <EquipmentExpander key={id} equipmentId={id}>
                {getTabContents(tab, id)}
              </EquipmentExpander>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default EquipSingleView;
